import React, { useState,useEffect ,useReducer} from 'react';

import '../../Assets/css/custom.css';
import '../../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";  

import CommonAPI from '../../Common/CommonAPI';
import CommonAPI2 from '../../Common/FD_BILL_APIs';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader";    
import SuccessMSG from "../../Common/SuccessMsg";
import SimpleReactValidator from 'simple-react-validator';
import { faPersonMilitaryToPerson } from '@fortawesome/free-solid-svg-icons';
import OTPModal from "../../Common/OTP"
import DownloadPDF from "../../Common/BillDownloadPDF"

function  BillPayment (props)  {    

  const [validator,setValidator] = useState(new SimpleReactValidator());
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  const [BillType,setBillType] = useState([]); 
  const [RegSelectedBill,setRegSelectedBill] = useState();
  const [RegesterBillTypeName,setRegesterBillTypeName] = useState();
  const [BillRegisterType,setBillRegisterType] = useState();
  const [BillingCode,setBillingCode] = useState();
  const [BillingAccount,setBillingAccount] = useState();
  const [BillServiceProvider,setBillServiceProvider] = useState([]);
  const [Password,setPassword] = useState();
  
  const [ServiceProviderName,setServiceProviderName] = useState();
  const [SuccessfulMSG,setSuccessfulMSG] = useState();  
  const [SelectFromAll,setSelectFromAll] =useState({});
  const [SelectFromAccount,setSelectFromAccount] =useState();
  const [SelectFromAccountID,setSelectFromAccountID] =useState();
  const [FromAccountList,setFromAccountList] =useState([]);
  const [AccountNumber,setAccountNumber] =useState();
  const [BillingId,setBillingId] =useState();
  const [EnterDate,setEnterDate] =useState();
  const [ EnteredAmount,setEnteredAmount] =useState();
  const [ YourRef,setYourRef] =useState("");
  const [ BeneRef,setBeneRef] =useState("");  
  const [ Recurring,setRecurring] =useState();
  const [ StartDate,setStartDate] =useState(new Date);
  const [ EndDate,setEndDate] =useState(new Date);
  const [ ScheduleDate,setScheduleDate] =useState(new Date);
  const [ Frequency,setFrequency] =useState();
  const [ ErrorMsg, setErrorMsg] =useState("");
  const [ OtpReference, setOtpReference] =useState("");
  const [ ShowReview, setShowReview] =useState(false);
  const [ ErrorPassword, setErrorPassword] =useState(false);
  const [ ReviewError, setReviewError] =useState(false);
  const [ SuccessLoading, setSuccessLoading] =useState(false);
  const [ ServiceProviderCode, setServiceProviderCode] =useState("");
  const [EnteredOTP,setEnteredOTP] = useState();
  const [BillSuccess,setBillSuccess] = useState(false);
  const [ConfirmOTP,setConfirmOTP] = useState(false);
  const [ PdfDownload,setPdfDownload] =useState(false);
  const [ReferenceNum,setReferenceNum] = useState();
  const [btnDisable,setbtnDisable] =useState(false);
  const [btnDisable2,setbtnDisable2] =useState(false);
  const [FromAccountAvailableBalance, setFromAccountAvailableBalance] = useState();

  const BillTypeAPI = ()=>{
    CommonAPI2.BillPaymentType((result)=>{
      setBillType(result);
    }
   )
  }
  const GetAccountsAPI = () =>{
    CommonAPI.FromToAccountAPI((results) =>{   
        if( results){                    
          setFromAccountList(results.data.mapAccountList?results.data.mapAccountList.filter(e=>(e.fromOrToAccount===1 && e.showByAccOpt)):null);                            
        }
    });
  }
  useEffect( () => {
    BillTypeAPI(); 
    GetAccountsAPI();       
  },[]);

  const ResponseLoadingModal = () => {
    return(
        <Modal
        size="lg"
        centered 
        className="loading1" show={SuccessLoading}>          
              <FadeLoader
              height={25}
              width={5}
              radius={2}
              margin={2}
              color={"#197b55"}
              size={"80px"} this also works
              loading={SuccessLoading}
            />       
       </Modal>
     )
  }

  const GetBillingAccount = (type)=> {

    var passValFrom = JSON.parse(type.target.value);        
    passValFrom ==='Select Bill'?
    setRegSelectedBill('')
    :setRegSelectedBill(passValFrom.type);
    setRegesterBillTypeName(passValFrom.name);
    setBillRegisterType(passValFrom.type); 
    setBillServiceProvider([]); 

    if(passValFrom.type){
        GetExistRecipientAPI(passValFrom.type)
    }
  }
  const GetExistRecipientAPI = (type) =>{
    CommonAPI2.GetExistBillRecipient({type:type},(result)=>{
      result.map((list,index)=>{        
          setBillingCode(list.code);
          setBillServiceProvider(result);        
      })
    })
  }
 
  const SelectFromOnChange = (event) => {
    var passValFrom = JSON.parse(event.target.value);
    setSelectFromAll(JSON.parse(event.target.value));
    setSelectFromAccount(passValFrom.accountNo?passValFrom.accountNo:null);
    setSelectFromAccountID(passValFrom.id?passValFrom.id:null); 
    setFromAccountAvailableBalance(passValFrom.avialableBalance?passValFrom.avialableBalance:null);         
 }

  const RegServiceProvider = (type) =>{
    var BillingCodeVal = JSON.parse(type.target.value);    
      setAccountNumber(BillingCodeVal.billingAccount);
      setBillingId(BillingCodeVal.id);  
      setEnterDate(BillingCodeVal.enterDate);
      setServiceProviderName(BillingCodeVal.provider)
      setServiceProviderCode(BillingCodeVal.providerCode);
  } 

  const ValidateFields = () =>{
    var FormatedDate = '';    
    if(Recurring==="N"){
      FormatedDate = moment(ScheduleDate).format('DD/MM/YYYY');
    }else{
      FormatedDate = moment(StartDate).format('DD/MM/YYYY');
    }
    if (!validator.allValid()) {
        validator.showMessages();
        // rerender to show messages for the first time
        // you can use the autoForceUpdate option to do this automatically`            
        forceUpdate();    
    }else if(EnteredAmount <= 0){
        setErrorMsg("Amount must be greater than 0");
    }else if((FormatedDate == moment(new Date()).format('DD/MM/YYYY')) && EnteredAmount>=(FromAccountAvailableBalance-100)){
      setErrorMsg("Insufficient balance")
    }else{
        setErrorMsg("");        
        CommonAPI.FetchOTPReference((results) =>{   
            if( results){                    
                setOtpReference(results);    
                console.log(results) ;                         
            }
        });
        setShowReview(true);
    }
  }

  const ReviewModal = ()=>{        
    return (
         <Modal
           show={ShowReview}
           size="md"
           aria-labelledby="contained-modal-title-vcenter"
           centered 
           backdrop="static"
           onHide = {()=>{setShowReview(false);setErrorPassword("")}}
         >
           <Modal.Header closeButton>
             <Modal.Title  id="contained-modal-title-vcenter">
               <p className='modal-head-f'>BILL PAYMENT</p><br/>REVIEW
             </Modal.Title>
           </Modal.Header>
           <Modal.Body>
             
             <Form >
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                        Bill Payment Type
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column >
                         {RegesterBillTypeName}
                     </Form.Label>                        
                     </Col>                     
                 </Form.Group>
                 <div>
                
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                        From
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column>
                     {SelectFromAccount}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                      Service Provider
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column>
                     {RegesterBillTypeName}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>                 
                 
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                     Billing Account
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column>
                     {AccountNumber}
                     </Form.Label>                        
                     </Col>
                 </Form.Group> 
                 </div>                 
                 
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                         Amount
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column>
                         {parseFloat(EnteredAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                     </Form.Label>                        
                     </Col>
                 </Form.Group> 
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                      Your Reference
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column>
                         {YourRef}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                      Payment Option
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column>
                         {Recurring==="R"||Recurring==="U"?"Recurring Payment"
                         :Recurring==="N"?"Non Recurring Payment":""}
                     </Form.Label>                        
                     </Col>
                 </Form.Group> 
                 {Recurring==="R" ||Recurring==="U"?
                 <div>          
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                     Start Date
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column >
                     {moment(StartDate).format("DD/MM/YYYY")}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                 
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                     Frequency
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column >
                         {Frequency==="D"?"Daily":Frequency==="W"?"Weekly"
                         :Frequency==="M"?"Monthly":Frequency==="Q"?"Quarterly"
                         :Frequency==="H"?"Half Yearly":Frequency==="Y"?"Yearly":"-"}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                 {Recurring==="U"?
                 <Form.Group as={Row} className="mb-1 margintop-f">
                 <Form.Label className="c-font" column sm={5} xs={5}>
                 End Date
                 </Form.Label>
                  <Col sm={7} xs={7}>
                      <Form.Label className="c-font" column >
                          Until Further notice
                      </Form.Label>                        
                  </Col>
                  </Form.Group>
                  
                  :
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                     End Date
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column >
                     {moment(EndDate).format("DD/MM/YYYY")}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                }
                 </div>: 
                 Recurring==="N"?
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                     Scheduled Date
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column >
                     {moment(ScheduleDate).format("DD/MM/YYYY")}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                 :null
                 
                 }
               
                 <Form.Group as={Row} className="mb-1 margintop-f">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                     OTP Reference
                     </Form.Label>
                     <Col sm={7} xs={7}>
                     <Form.Label className="c-font" column >
                         {OtpReference}
                     </Form.Label>                        
                     </Col>
                 </Form.Group>
                  <Form.Group as={Row} className="mb-1 margintop-f3">
                     <Form.Label className="c-font" column sm={5} xs={5}>
                      Password
                     </Form.Label>
                     <Col sm={7} xs={7}>                         
                        <Form.Control 
                        maxLength={8}
                        value={Password}
                        onChange={(text)=>setPassword(text.target.value)}
                        className={!Password?"form-h2 password-f":"form-h2"} size="sm" type="password" placeholder="Password" />
                        <p className='vali-txt'>{ErrorPassword}</p>                                                       
                        <p className='vali-txt'>{ReviewError}</p>             
                     </Col>
                     
                 </Form.Group>
             </Form>
           </Modal.Body>
         
            <Modal.Footer className="mb-1 margintop-f2">                
             <Button className="btn-logout" 
             disabled={btnDisable2}
             onClick={()=>{
              setShowReview(false);
              setbtnDisable2(true);              
              CheckFirstPassword()}} 
             >
              Confirm
            </Button>
           </Modal.Footer>
            
         </Modal>
       );         
   }

   const CheckFirstPassword = () =>{   
    setSuccessLoading(true);
    setTimeout(()=>{
      CommonAPI.CheckPassword({password:Password},(results) =>{   
        if(results.password==="true"){  
            setErrorPassword("");
            setShowReview(false);  
            setbtnDisable2(false);           
            CreateBillAPI();    
        }else if(results.password==="false"){ 
            setSuccessLoading(false); 
            setbtnDisable2(false);         
            setShowReview(true);
            setErrorPassword("Incorrect Password");
            setReviewError();
        }
      }) 
    },100)
     
    }

    const CreateBillAPI = () =>{
      var DueDate = '';
      var BillEndDate = '';

      if(Recurring==="R" ){
        DueDate = moment(StartDate).format("YYYY-MM-DD");
        BillEndDate = moment(EndDate).format("YYYY-MM-DD");
      }else if(Recurring==="U"){
        BillEndDate=" ";
        DueDate = moment(StartDate).format("YYYY-MM-DD");
      }else if(Recurring==="N"){
        BillEndDate=" ";
        DueDate = moment(ScheduleDate).format("YYYY-MM-DD");
      }
      CommonAPI2.CreateBillPayment({
        DueDate:DueDate,
        EndDate:Recurring==="N"? DueDate:BillEndDate,
        ServiceProviderName:ServiceProviderName,
        ServiceProviderCode:ServiceProviderCode,
        ExistEnteredAmount:EnteredAmount,
        SavingsAccountNum:SelectFromAccount,
        BillingAccNum:AccountNumber,
        SelectedFrequency:Recurring==="N"?"":Frequency,
        CheckRecurring:Recurring==="N"?"S":"R",
        OtpReference:OtpReference,
        BillBeneRef:BeneRef,
        BillYourRef:YourRef,
      },(result)=>{
        if(result.status==="SUCCESS_WITH_OTP"){
          setShowReview(false);
          setConfirmOTP(true);
          setSuccessLoading(false); 
          GetAccountsAPI(); 
          setbtnDisable2(false)    
        }else if(result.status==="SUCCESS_WITHOUT_OTP"|| result.status==="SUCCESS_WITHOUT_OTP_FUTURE_PAYMENT"|| result.status==="SUCCESS_WITHOUT_OTP_FUTURE_PAYMENT_CRE"){
          setShowReview(false);
          GetAccountsAPI(); 
          setSuccessLoading(false); 
          setReferenceNum(result.billTransRef);
          setBillSuccess(true);
          setbtnDisable2(false)
        }else{          
          setErrorPassword(result?result.description:"");
          setSuccessLoading(false); 
          setbtnDisable2(false)
        }
      })
    }

    const ConfirmOtpTransfer= ()=>{
      
      setSuccessLoading(true);
      setTimeout(()=>{
        CommonAPI2.AcceptBillPayment({EnteredOTP:EnteredOTP},(result)=>{
          result.map((ListValue,index)=>{
              if(ListValue.message==="SUCCESS"||ListValue.message==="SUCCESS FUTURE PAYMENT"||ListValue.message==="SUCCESS FUTURE PAYMENT CRE"){
                  setSuccessLoading(false);
                  setbtnDisable(false);
                  setBillSuccess (true) ;
                  setConfirmOTP(false);
                  setReferenceNum(ListValue.otherInformation.billTransRef);
              }else{
                  setSuccessLoading(false); 
                  setbtnDisable(false);                
                  setReviewError(ListValue.otherInformation.description?ListValue.otherInformation.description:"");
              }
            })
      })
      },100)
     
    }
    const ResendOTP = () =>{
      CommonAPI.ResendOTP({OtpReference:OtpReference},(results)=>{
          if(results){
              OtpReference(results.otpRef)
          }
      });
  }

  const resetForm = () =>{
    setSelectFromAll([]);  
    setSelectFromAccount("");   
    setAccountNumber("");
    setEnteredAmount("");
    setYourRef("");
    setPdfDownload(false);
    
    setRecurring("");
  }
  const callToPDF = () =>{
    setBillSuccess(false)        
    setPdfDownload(true);
  }
  var C_Name = JSON.parse(sessionStorage.getItem("NIC"));
  
        if(ShowReview){
          return ( <div>{ReviewModal()}</div> );
        }else if(SuccessLoading){
          return ( <div>{ResponseLoadingModal()}</div> );
        }else if(ConfirmOTP){
          return ( 
          <div>
              <OTPModal ConfirmOTP={ConfirmOTP} setConfirmOTP={()=>setConfirmOTP(false)} 
              EnteredValue={(e)=>{setEnteredOTP(e.target.value)}} 
              Confirm={()=>{setbtnDisable(true);ConfirmOtpTransfer()}}
              FailMsg={ReviewError} ResendOTP={ResendOTP} />
          </div> );
        }
        else if(BillSuccess){
          return ( 
          <div>
              <SuccessMSG ConfirmSuccess={BillSuccess} onHide={()=>setBillSuccess(false)} 
              Close={callToPDF} head="BILL PAYMENT" head2="SUCCESS" 
              contentline1="Bill Payment Completed Successfully"/>
          </div> );
      }else if(PdfDownload){
        return(
          <DownloadPDF show={PdfDownload} onHide={resetForm} 
          senderAccount={SelectFromAccount}  paydate={moment(new Date()).format('DD/MM/YYYY')}
          senderName={C_Name.title+" "+C_Name.UserFirstname+" "+C_Name.UserLastname}
          beneName={RegesterBillTypeName}
          refNum={ReferenceNum} 
          billingAccount={AccountNumber}
          amount={parseFloat(EnteredAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
          startDate={Recurring==="R" ||Recurring==="U"?moment(StartDate).format("DD/MM/YYYY"):null}
          frequency={Recurring==="R" ||Recurring==="U"?(Frequency==="D"?"Daily":Frequency==="W"?"Weekly"
          :Frequency==="M"?"Monthly":Frequency==="Q"?"Quarterly"
          :Frequency==="H"?"Half Yearly":Frequency==="Y"?"Yearly":"-"):null}
          endDate={(Recurring==="R" || Recurring==="U")?(Recurring==="U"?"Until Further notice":moment(EndDate).format("DD/MM/YYYY")):null}
          scheduledDate={Recurring==="N"?moment(ScheduleDate).format("DD/MM/YYYY"):null}
          type={"Bill Payment"}
          >
          
          <div className='d-flex flex-row s-top'>
            <p className=' form-h2 t-width1'>Billing Account Number</p>
            <p className='t-width2 form-h2'>
            {AccountNumber}
            </p>
        </div>
          <div className='d-flex flex-row s-top'>
            <p className=' form-h2 t-width1'>Amount Paid Rs</p>
            <p className='t-width2 form-h2'>
            {parseFloat(EnteredAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
            </p>
        </div>
        {Recurring==="R" ||Recurring==="U"?
         <div>
          <div className='d-flex flex-row s-top'>
              <p className=' form-h2 t-width1'>Start Date</p>
              <p className='t-width2 form-h2'>
              {moment(StartDate).format("DD/MM/YYYY")}
              </p>
          </div> 
          <div className='d-flex flex-row s-top'>
              <p className=' form-h2 t-width1'>Frequency</p>
              <p className='t-width2 form-h2'>
              {Frequency==="D"?"Daily":Frequency==="W"?"Weekly"
                :Frequency==="M"?"Monthly":Frequency==="Q"?"Quarterly"
                :Frequency==="H"?"Half Yearly":Frequency==="Y"?"Yearly":"-"}
              </p>
          </div> 
          <div className='d-flex flex-row s-top'>
              <p className=' form-h2 t-width1'>End Date</p>
              <p className='t-width2 form-h2'>
              {Recurring==="U"?"Until Further notice":moment(EndDate).format("DD/MM/YYYY")}
              </p>
          </div>
        </div>:
         Recurring==="N"?
                <div className='d-flex flex-row s-top'>
                  <p className=' form-h2 t-width1'>Scheduled Date</p>
                  <p className='t-width2 form-h2'>
                    {moment(ScheduleDate).format("DD/MM/YYYY")}
                  </p>
                </div> :
                null
        }
          </DownloadPDF>
        )
      }else{
        return (

            <Modal
              show={props.isOpen}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title  id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>BILL</p><br/>PAYMENTS
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
                <Form >
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label className="c-font" column sm={4}>
                            Bill Payment Type
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select 
                        onChange={GetBillingAccount.bind(this)}
                        size="sm" 
                        className="form-h2 ">
                            <option value={JSON.stringify("Select Bill")}>Select</option>
                            {BillType?BillType.map((listValue,index)=> {
                              return(<option key={index} value={JSON.stringify(listValue)}>{listValue.name}</option>)
                            }):null
                            }                           
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('Billype', RegesterBillTypeName, 'required')}</p>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                         Payment By Account
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select size="sm"
                         value={JSON.stringify(SelectFromAll)} 
                        onChange={SelectFromOnChange}
                        className="form-h2 ">
                            <option value={JSON.stringify("select")}>Select</option>
                            {FromAccountList?FromAccountList.filter((e)=>e.jointAccountVisibility===true).map((listValue,index)=>{
                                 return (
                                 <option  key={index} value={JSON.stringify(listValue)}>
                                   A / N : {listValue.accountNo} | Balance : Rs {parseFloat(listValue.avialableBalance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                                  </option>)
                              }):
                              null
                              }
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('account', SelectFromAccount, 'required')}</p>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                           Billing Account
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select

                         onChange={RegServiceProvider.bind(this)}
                         size="sm" className="form-h2 ">
                            <option value={JSON.stringify("Select Service Provider")}>-Select Service Provider-</option>
                          {BillServiceProvider.map((ListValue,index)=> {
                            return(<option value={JSON.stringify(ListValue)}>{ListValue.provider}{" - "+ListValue.billingAccount}</option>)
                          })
                          }
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('account', AccountNumber, 'required')}</p>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                            Payment Amount Rs.
                        </Form.Label>
                        <Col sm={8}>                        
                        <Form.Control 
                         value={EnteredAmount}
                         onChange={(text)=>setEnteredAmount(text.target.value)}
                         className="form-h2" size="sm" type="number" placeholder="Amount" />
                         <p className='vali-txt'>{validator.message('amount', EnteredAmount, 'required')}</p>
                        </Col>
                        
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1 margintop-f" >
                        <Form.Label className="c-font" column sm={4}>
                          Your Reference
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Control
                        maxLength='14'                        
                        value={YourRef}
                        onChange={(e)=> setYourRef(e.target.value)}
                         className="form-h2" 
                         size="sm" type="text" placeholder="Your Reference" />
                        </Col>
                    </Form.Group>
                    
                    <Form.Group as={Row} className="mb-1" >
                        <Form.Label className="c-font" column sm={4}>
                            Payment Method
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select 
                        value={Recurring}
                        onChange={(e)=>setRecurring(e.target.value)}
                        size="sm" className="form-h2 ">
                            <option value="">Select</option>
                            <option value="N">Non Recurring Payment</option>
                            <option value="R">Set Up Recurring Payment</option>
                            <option value="U">Set Up Recurring Payment Until Further Notice</option>
                            
                        </Form.Select>
                        <p className='vali-txt'>{validator.message('Payment method', Recurring, 'required')}</p>

                        </Col>
                    </Form.Group>
                    {Recurring?
                    <Form.Group as={Row} className="mb-1 margintop-f">
                        <Form.Label className="c-font" column sm={4}>
                         Payment Date
                        </Form.Label>
                        {Recurring==="R"?
                        <Col sm={8} >
                            <div className='d-flex flex-row align-items-center'>                                
                              <DatePicker
                                  className="datepicker4 m-leftm"
                                  selected={StartDate}
                                  onChange={(e)=>setStartDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />
                              <label className='lable l-width t-center'> To</label> 
                              <DatePicker
                                  className="datepicker4 m-rightm"
                                  selected={EndDate}
                                  onChange={(e)=>setEndDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />
                            </div>                  
                        </Col>
                        :Recurring==="U"?
                        <Col sm={8} className="mb-1 ">
                            <div className='d-flex flex-row align-items-center'>                                
                              <DatePicker
                                  className="datepicker5 m-leftm"
                                  selected={StartDate}
                                  onChange={(e)=>setStartDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />
                              <label className='lable l-width t-center'> To</label> 
                              <p className="p-line4 xs-top2">Until Further Notice</p>
                            </div>                  
                        </Col>
                        :Recurring==="N"?
                        <Col sm={8} >
                            <div className='d-flex  form-h2 flex-row align-items-center'>                                
                              <DatePicker
                                  className="datepicker5 m-leftm"
                                  selected={ScheduleDate}
                                  onChange={(e)=>setScheduleDate(e)}
                                  dateFormat="dd/MM/yyyy"
                                  minDate={new Date()}
                              />
                              
                            </div>                  
                        </Col>:
                        null
                        }
                    </Form.Group>
                    :null}
                    {Recurring!=="N"?
                    <Form.Group as={Row} className="mb-1 margintop-f3" >
                        <Form.Label className="c-font" column sm={4}>
                            Frequency
                        </Form.Label>
                        <Col sm={8}>
                        <Form.Select 
                         onChange={(e)=>setFrequency(e.target.value)}
                        size="sm" className="form-h2 ">
                            <option value="">Select</option>
                            <option value="M">Monthly</option>
                            <option value="D">Daily</option>
                            <option value="W">Weekly</option>
                            <option value="Q">Quarterly</option>
                            <option value="H">Half Yearly</option>
                            <option value="Y">Yearly</option>                            
                        </Form.Select>
                        
                        
                        </Col>
                    </Form.Group>:
                    null}
                </Form>
                <p className='vali-txt'>{ErrorMsg}</p>
              </Modal.Body>
              <Modal.Footer className="mb-1 margintop-f2">                
                <Button className="btn-logout" onClick={()=>ValidateFields()}>Process Transfer</Button>
              </Modal.Footer>
            </Modal>
          );
        }
    }

export default BillPayment;